import {
    ACHIEVEMENT_DELETED,
    ACHIEVEMENT_DELETING,
    ACHIEVEMENT_DOWNLOADED,
    ACHIEVEMENT_EDITING,
    ACHIEVEMENT_POSTING,
    ACHIEVEMENT_RESET,
    ACHIEVEMENTS_DOWNLOADED,
    ACHIEVEMENTS_FAILED,
    ACHIEVEMENTS_PENDING,
    ACHIEVEMENT_PICTURE_UPLOADING,
    ACHIEVEMENT_PICTURE_FAILED,
    ACHIEVEMENT_UNEARNED_PICTURE_UPLOADING,
    ACHIEVEMENT_UNEARNED_PICTURE_FAILED,
} from './types';
import LangService from '../../services/lang';

export const INITIAL_STATE = {
    error: null,
    content: LangService.defaultTranslatedContent,
    pending: false,
    sending: false,
    currentAchievement: null,
    currentIndex: null
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case ACHIEVEMENT_RESET:
            return INITIAL_STATE;
        case ACHIEVEMENTS_PENDING:
            return {
                ...state,
                pending: true,
            };
        case ACHIEVEMENTS_FAILED:
            return {
                ...state,
                pending: false,
                sending: false,
                error: action.payload,
            };
        case ACHIEVEMENTS_DOWNLOADED: {
            let newContentPages = { ...state.content };
            newContentPages[action.payload.lang] = action.payload.achievements;
            return {
                ...state,
                error: null,
                pending: false,
                sending: false,
                content: newContentPages,
            };
        }
        case ACHIEVEMENT_DOWNLOADED: {
            let newContent = {...state.content};
            let index = newContent[action.payload.lang]
                .findIndex(ac => ac.id === action.payload.achievement.id);
            if (index === -1) {
                newContent[action.payload.lang].push(action.payload.achievement);
            } else {
                newContent[action.payload.lang][index] = action.payload.achievement;
            }
            return {
                ...state,
                content: newContent,
                currentAchievement: action.payload.achievement,
                error: null,
                sending: false,
                pending: false,
            };
        }
        case ACHIEVEMENT_DELETING:
            return {
                ...state,
                sending: true,
            };
        case ACHIEVEMENT_POSTING:
            return {
                ...state,
                sending: true,
            };
        case ACHIEVEMENT_DELETED: {
            let newContent = { ...state.content };
            LangService.langs.forEach(function (l) {
                if (newContent[l.key] !== undefined) {
                    newContent[l.key] = state.content[l.key].filter((ac) => {
                        return ac.id !== action.payload.id;
                    });
                }
            });
            return {
                ...state,
                content: newContent,
                error: null,
                sending: false,
            };
        }
        case ACHIEVEMENT_EDITING:
            return {
                ...state,
                sending: true,
            };
        case ACHIEVEMENT_PICTURE_UPLOADING:
            return {
                ...state,
                sending: true
            }
        case ACHIEVEMENT_PICTURE_FAILED:
            return {
                ...state,
                sending: false,
                error: action.payload
            }
        case ACHIEVEMENT_UNEARNED_PICTURE_UPLOADING:
            return {
                ...state,
                sending: true
            }
        case ACHIEVEMENT_UNEARNED_PICTURE_FAILED:
            return {
                ...state,
                sending: false,
                error: action.payload
            }
        default:
            break;
    }

    return state;
}



// WEBPACK FOOTER //
// src/store/achievements/reducers.js